<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <switch-buttons :template-id="templateId"></switch-buttons>
      <div class="form-group form-row" v-if="datasetId">
        <label :for="safeId('record')" class="col-sm-4 col-form-label">Record</label>
        <div class="col-sm-8">
          <record-select :id="safeId('record')" v-model="recordId" :dataset-id="datasetId"></record-select>
        </div>
      </div>
      <div class="form-group form-row" v-if="datasetId">
        <div class="col-sm-4"></div>
        <div class="col-sm-8">
          <button type="button" class="btn btn-block btn-primary" @click="nextRecord(recordId, datasetId)">Next</button>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('title')" class="col-sm-4 col-form-label">Titel</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('title')" v-model.lazy="title">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('alter')" class="col-sm-4 col-form-label">Alter</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('alter')" v-model.lazy="alter">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('groesse')" class="col-sm-4 col-form-label">Grösse</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('groesse')" v-model.lazy="groesse">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('gewicht')" class="col-sm-4 col-form-label">Gewicht</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('gewicht')" v-model.lazy="gewicht">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('beruf')" class="col-sm-4 col-form-label">Beruf</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('beruf')" v-model.lazy="beruf">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('wohnort')" class="col-sm-4 col-form-label">Wohnort</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('wohnort')" v-model.lazy="wohnort">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('totalKraenze')" class="col-sm-4 col-form-label">Total Kränze</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('totalKraenze')" v-model.lazy="totalKraenze">
        </div>
      </div>
    </window-tab>
    <window-tab title="Data" icon="database">
      <div class="form-group form-row">
        <label :for="safeId('datasetId')" class="col-sm-4 col-form-label">Dataset</label>
        <div class="col-sm-8">
          <dataset-select :id="safeId('datasetId')" v-model="datasetId"></dataset-select>
        </div>
      </div>
      <div class="form-group form-row">
        <label class="col-sm-4 col-form-label">Fields</label>
        <div class="col-sm-8">
          <input type="text" readonly class="form-control-plaintext" :value="datasetColumns">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternTitle')" class="col-sm-4 col-form-label">Titel</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternTitle')" v-model.lazy="patternTitle">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternAlter')" class="col-sm-4 col-form-label">Alter</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternAlter')" v-model.lazy="patternAlter">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternGroesse')" class="col-sm-4 col-form-label">Grösse</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternGroesse')" v-model.lazy="patternGroesse">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternGewicht')" class="col-sm-4 col-form-label">Gewicht</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternGewicht')" v-model.lazy="patternGewicht">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternBeruf')" class="col-sm-4 col-form-label">Beruf</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternBeruf')" v-model.lazy="patternBeruf">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternWohnort')" class="col-sm-4 col-form-label">Wohnort</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternWohnort')" v-model.lazy="patternWohnort">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternTotalKraenze')" class="col-sm-4 col-form-label">Total Kränze</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternTotalKraenze')" v-model.lazy="patternTotalKraenze">
        </div>
      </div>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <template-settings :templateId="templateId"></template-settings>
    </window-tab>
  </window>
</template>

<script>
  import { templateMixin } from '@/mixins'
  import { mapOverlayData, mapTemplateData } from '../../utils/index'
  import * as action from '@/store/action-types'

  export default {
    name: 'swiss-wrestling-steckbrief',
    mixins: [templateMixin],
    computed: {
      ...mapOverlayData(['title', 'alter', 'groesse', 'gewicht', 'beruf', 'wohnort', 'totalKraenze']),
      ...mapTemplateData(['datasetId', 'recordId']),
      ...mapTemplateData({
        /* eslint-disable no-template-curly-in-string */
        patternTitle: {default: `$\{lastName} $\{firstName} $\{a_sterne} $\{a_verband}`},
        patternAlter: {default: '${birthdate}'},
        patternGroesse: {default: '${a_groesse}'},
        patternGewicht: {default: '${a_gewicht}'},
        patternBeruf: {default: `$\{a_beruf}`},
        patternWohnort: {default: `$\{a_wohnort}`},
        patternTotalKraenze: {default: `$\{a_totalKraenze}`}
        /* eslint-enable no-template-curly-in-string */
      }),
      dataset () {
        if (!this.datasetId) return null
        return this.$store.getters.dataset(this.datasetId)
      },
      datasetColumns () {
        if (!this.dataset) return
        return this.dataset.columns || []
      }
    },
    watch: {
      sponsorsAlbumId: function (val) {
        const album = this.$store.getters.album(val) || {}
        this.$store.dispatch(action.TEMPLATE_OVERLAY_DATA, {
          templateId: this.templateId,
          data: {sponsors: album.pictures}
        })
      },
      recordId: function (val) {
        if (!val) return
        let record = this.$store.getters.dataset(this.datasetId).records
          .find(r => r.recordId === val)
        if (!record) return
        record = this.mapRecord(record)
        this.title = record.title
        this.alter = record.alter
        this.groesse = record.groesse
        this.gewicht = record.gewicht
        this.beruf = record.beruf
        this.wohnort = record.wohnort
        this.totalKraenze = record.totalKraenze
      }
    },
    methods: {
      nextRecord (prevRecordId, datasetId) {
        const records = this.$store.getters.datasetRecords(datasetId)
        const index = records.findIndex(p => p.recordId === prevRecordId)
        this.recordId = records.length > index + 1 ? records[index + 1].recordId : records[0].recordId
      },
      mapRecord (record) {
        const result = {}
        const recordMap = {
          title: this.patternTitle,
          alter: this.patternAlter,
          groesse: this.patternGroesse,
          gewicht: this.patternGewicht,
          beruf: this.patternBeruf,
          wohnort: this.patternWohnort,
          totalKraenze: this.patternTotalKraenze
        }
        for (let k in recordMap) {
          if (!recordMap.hasOwnProperty(k)) continue
          result[k] = recordMap[k].replace(/\$\{([\w ]+)\}/g, function (match, p1) {
            return record[p1] || ''
          })
        }
        return result
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/templates/swiss-wrestling-steckbrief.vue